<template>
    <ds-tooltip position="top" :disabled="isOpen || !showTooltip">
        <template #reference>
            <ds-dropdown
                v-show="mergeFieldOptions.length"
                class="merge-field-dropdown"
                data-qa="merge-field-dropdown"
                :is-open="isOpen"
                :position="position"
                @close="closeMenu"
            >
                <template #default>
                    <slot name="action" />
                </template>

                <template #menu>
                    <ds-multiselect-menu
                        v-if="isOpen"
                        v-model="selectedMergeField"
                        data-qa="merge-field-menu"
                        class="multiselect-menu"
                        categorized
                        :categories-label="$t('components.shared.mergeFieldDropdown.categoryTitle')"
                        :options="filteredMergeFields"
                        @menuItemChanged="emitOpenMenu"
                        @input="setSelected"
                    />
                </template>
            </ds-dropdown>
        </template>

        <template #default>
            <span>{{ $t('components.shared.mergeFieldDropdown.tooltip') }}</span>
        </template>
    </ds-tooltip>
</template>

<script>
import { POPOVER_POSITIONS } from './constants/popover.constants';

const CUSTOM_FIELD_CATEGORY = 'customFields';
const MERGE_FIELD_BLOCK_LIST = ['[[contact.uid]]', '[[contact.owner.uid]]', '{{user.uid}}'];

export default {

    props: {
        hideBorders: Boolean,
        hideCustomFields: Boolean,
        isOpen: Boolean,
        value: Object,
        mergeFieldCategories: {
            type: Array,
            required: true,
        },
        position: {
            type: String,
            validator: (value) => POPOVER_POSITIONS.includes(value),
            default: 'bottom-end',
        },
        showTooltip: Boolean,
    },

    data() {
        return {
            selectedMergeField: this.value,
        };
    },

    computed: {
        hasMergeFields() {
            return this.mergeFieldCategories?.length > 0;
        },

        filteredMergeFields() {
            if (!this.hideCustomFields) {
                return this.mergeFieldOptions;
            }

            return this.mergeFieldOptions
                .filter(({ category }) => category.value !== CUSTOM_FIELD_CATEGORY);
        },

        mergeFieldOptions() {
            if (!this.mergeFieldCategories) {
                return [];
            }

            return this.mergeFieldCategories
                .map(this.mapCategoryToOptions)
                .filter(this.hasOptions);
        },
    },

    methods: {
        closeMenu() {
            this.$emit('menuClosed');
        },

        emitOpenMenu() {
            this.$emit('menuOpen');
        },

        fieldNotInBlockList(mergeField) {
            return !MERGE_FIELD_BLOCK_LIST.includes(mergeField.value);
        },

        hasOptions({ options }) {
            return options?.length > 0 ?? false;
        },

        mapCategoryToOptions({ label, value, fields }) {
            return {
                category: { label, value },
                options: fields.filter(this.fieldNotInBlockList),
            };
        },

        setSelected() {
            this.$emit('select', this.selectedMergeField);
            this.closeMenu();
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
.merge-field-dropdown {
    padding: 0;
    width: var(--merge-field-dropdown-width, auto);
}

.merge-field-dropdown::v-deep ul {
    margin: 0;
}
</style>
